import api from '../../api/leadRealAPI'
import router from '../../router'
import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

export default {
  namespaced: true,

  state: {
    userData: null,
    deleteMsg: null,
    propertyData: [
      {
        property: {
          page_status: null,
          administrative_title: null,
          property_category: null,
          prefecture: null,
          language: 'name_ja',
          type_of_property: null,
          property_name: null,
          copy: null,
          building_price: null,
          property_price: null,
          land_price: null,
          yields: null,
          estimated_annual_income: null,
          street_address: null,
          nearest_station: null,
          building_area: null,
          land_area: null,
          date_of_construction: null,
          floor: null,
          construction: null,
          unit_price: null,
          total_unit: null,
          number_of_unit_sold: null,
          building_coverage_ratio: null,
          floor_area_ratio: null,
          setback: null,
          floor_plan_type: null,
          floor_plan_details: null,
          facility: null,
          current_situation: null,
          land_rights: null,
          ground: null,
          area_of_use: null,
          city_planning: null,
          parking_lot: null,
          roadside_situation: null,
          driveway_burden: null,
          main_lighting_surface: null,
          delivery_date: null,
          transaction_mode: null,
          information_disclousure_date: null,
          inspection_certificate: null,
          remarks: null,
          mainVideo: [{
            url: ''
          }],
          mainImage: [{
            url: ''
          }],
          subImage: [{
            url: ''
          }],
          google_map_url: null,
          chatbot_url: null
        }
      }
    ],
    properties: null
  },

  getters: {
    user: state => state.userData,
    propertyData: state => state.propertyData,
    properties: state => state.properties,
    deleteMsg: state => state.deleteMsg
  },

  mutations: {
    setUserData (state, user) {
      state.userData = user
    },
    setProperties (state, properties) {
      state.properties = properties
    },
    setProperty (state, propertyData) {
      state.propertyData = propertyData
    },
    setDeleteMsg (state, deleteMsg) {
      state.deleteMsg = deleteMsg
    }
  },

  actions: {
    addProperty ({ commit }, { data, apiType }) {
      const dataImage = new FormData()
      if (data.mainImage !== null) {
        dataImage.append('imageName', data.mainImage.name)
        dataImage.append('mainImage', data.mainImage)
      }
      if (data.subImage !== null) {
        data.subImage.forEach((photo, index) => {
          dataImage.append('subImage' + index, photo)
          dataImage.append('subName' + index, photo.name)
        })
      }
      dataImage.append('value', JSON.stringify((data.newData)))
      api
        .post(`${apiType}/newProperty`, dataImage)
        .then(response => {
          const property = response.data.data.property[0]
          if (apiType === 'admin') {
            router.push({ name: 'Edit Property Information', params: { id: property.property[0].property_id, language: property.property[0].language } })
          } else if (apiType === 'member') {
            router.push({ name: 'business-property-edit', params: { id: property.property[0].property_id, language: property.property[0].language } })
          }

          commit('setApiStatus', response.data.status, { root: true })
          setTimeout(() => commit('setApiStatus', null, { root: true }), 3000)
        })
    },
    getAllProperties ({ commit }, { type, apiType }) {
      api
        .get(`${apiType}/properties/${type}`)
        .then(response => {
          commit('setProperties', response.data)
        })
        .catch(() => {})
    },
    getProperty ({ commit }, { propertyId, apiType }) {
      commit('setProperty', null)
      api
        .get(`/${apiType}/specificProperty/` + propertyId)
        .then(response => {
          commit('setApiStatus', null, { root: true })
          commit('setProperty', response.data.data)
        })
        .catch(() => {})
    },
    deleteProperty ({ commit }, { data, apiType }) {
      api
        .post(`${apiType}/deleteProperty/` + data)
        .then(response => {
          commit('setDeleteMsg', response.data.status)
          setTimeout(() => commit('setDeleteMsg', null), 3000)

          if (apiType === 'admin') {
            router.push({ name: 'Property List' })
          } else if (apiType === 'member') {
            router.push({ name: 'business-property-list' })
          }
        })
        .catch(() => {})
    },
    deleteImage ({ commit, state }, data) {
      const imageRemove = state.propertyData.property[data[0]].properties_images
      const removeImage = imageRemove.filter(image => image.index !== data[1])
      state.propertyData.property[data[0]].properties_images = removeImage
    },
    updateImageViaFile ({ commit, state }, data) {
      if (data.status === 'mainImage') {
        state.propertyData.property[data.key].properties_images[0].images.url = data.updateImage
      } else {
        state.propertyData.property[data.key].properties_images[data.index].images.url = data.updateImage
      }
    },
    statusPageList ({ state }, data) {
      const languageName = data.language
      state.propertyData.property_types[languageName] = data.status
    },
    updateProperty ({ dispatch, commit }, { data, apiType }) {
      const dataImage = new FormData()
      const language = ['日本語', '英語', '簡体字', '繁体字']
      language.forEach(element => {
        if (data.mainImageFile[element] !== null) {
          dataImage.append(element + '-mainImage', data.mainImageFile[element])
          dataImage.append(element + '-mainImage' + 'name', data.mainImageFile[element].name)
        }
        data.subImageFile[element].forEach(elemented => {
          if (elemented.type === 'exist') {
            dataImage.append(element + '-subImage' + elemented.index, elemented.file)
            dataImage.append(element + '-subImage' + elemented.index + 'name', elemented.file.name)
          } else {
            dataImage.append(element + '-newImage' + elemented.index, elemented.file)
            dataImage.append(element + '-newImage' + elemented.index + 'name', elemented.file.name)
          }
        })
      })
      dataImage.append('value', JSON.stringify((data.dataValue)))
      api
        .post(`${apiType}/editAndCreateProperty/` + data.dataValue.property.id, dataImage)
        .then(response => {
          dispatch('getProperty', { propertyId: response.data.data[0].id, apiType: apiType })
          commit('setApiStatus', response.data.status, { root: true })
          setTimeout(() => commit('setApiStatus', null, { root: true }), 3000)
        })
        .catch(() => {})
    }
  }
}
